import { render, staticRenderFns } from "./kjfw.vue?vue&type=template&id=282b8260&scoped=true&"
import script from "./kjfw.vue?vue&type=script&lang=js&"
export * from "./kjfw.vue?vue&type=script&lang=js&"
import style0 from "./kjfw.vue?vue&type=style&index=0&id=282b8260&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282b8260",
  null
  
)

export default component.exports